import Image from 'next/image';
import Link from 'next/link';
import { getEdgeUrl } from '@/lib/getEdgeUrl';
import i18n from '@/settings/i18n';

const t = i18n.init('shared');

const DefaultBanner = ({ closeMenu }: { closeMenu: () => void }) => (
  <div className="px-5 py-2.5">
    <Link href="/collections/hot-deals" onClick={closeMenu} className="group">
      <div
        className="flex h-[70px] items-center justify-between gap-x-5 rounded-lg px-3" // eslint-disable-next-line react/forbid-dom-props
        style={{
          background:
            'linear-gradient(90deg, rgba(123,53,53,1) 0%, rgba(31,35,35,1) 40%, rgba(31,35,35,1) 100%)',
        }}
      >
        <div className="h-16">
          <Image
            src={getEdgeUrl('images/hot-deals/menu/default.png')}
            alt="Hot Deals"
            height={100}
            width={200}
            className="h-full w-auto rounded-tl-xl object-cover object-right"
          />
        </div>
        <div className="shrink-0 rounded-full bg-red px-4 py-2 text-xs font-semibold text-white group-hover:underline">
          {t`Browse Deals`}
        </div>
      </div>
    </Link>
  </div>
);

export default DefaultBanner;
